import { useState } from 'react';
import { Building2, Landmark, Layers, Users } from 'lucide-react';
import { PageHeader, Tabs } from '@/components/ui';
import { CentresCoutTab } from './CentresCoutTab';
import { EntrepriseTab } from './EntrepriseTab';
import { ParametresFiscauxTab } from './ParametresFiscauxTab';
import { UtilisateursTab } from './UtilisateursTab';

const TABS = [
  { key: 'entreprise', label: 'Entreprise', icon: <Building2 className="size-4" /> },
  { key: 'utilisateurs', label: 'Utilisateurs', icon: <Users className="size-4" /> },
  { key: 'fiscaux', label: 'Paramètres fiscaux', icon: <Landmark className="size-4" /> },
  { key: 'centres', label: 'Centres de coûts', icon: <Layers className="size-4" /> },
];

export function ParametresPage() {
  const [tab, setTab] = useState('entreprise');

  return (
    <>
      <PageHeader
        title="Paramètres"
        subtitle="Configuration de l'entreprise, des comptes et des règles fiscales"
        breadcrumbs={[{ label: 'Advanced Works ERP' }, { label: 'Paramètres' }]}
      />

      <Tabs tabs={TABS} value={tab} onChange={setTab} className="mb-6" />

      {tab === 'entreprise' && <EntrepriseTab />}
      {tab === 'utilisateurs' && <UtilisateursTab />}
      {tab === 'fiscaux' && <ParametresFiscauxTab />}
      {tab === 'centres' && <CentresCoutTab />}
    </>
  );
}
